import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class HubTokenTransferService {

    private readonly receiverUrl = `${environment.HUB_ENDPOINT}/assets/tokens-receiver.html`;
    private readonly hubDomain = environment.HUB_ENDPOINT;

    sendAuthDataToHub(accessToken: string, refreshToken: string, userProfile: any, redirectUserAfterOnload: boolean): void {
        if (!accessToken || !refreshToken || !userProfile) return;

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = `${this.receiverUrl}?origin=${encodeURIComponent(window.location.origin)}`;
        iframe.onload = () => {
            requestAnimationFrame(() => {
                iframe.contentWindow?.postMessage(
                    { type: 'CPS_TOKEN_SYNC', payload: { accessToken, refreshToken, userProfile } },
                    this.hubDomain
                );

                if (redirectUserAfterOnload) {
                    window.location.href = environment.HUB_ENDPOINT + '/home';
                }
            });
        };

        iframe.onerror = () => {
            console.error("Failed to load tokens receiver iframe:", this.receiverUrl);
        };

        document.body.appendChild(iframe);
    }
}
